<template>
  <div class="head_wrap_degin">
    <div class="head_other">
      <el-button @click="clearModle" size="small">更换模板</el-button>
      <el-button @click="saveSubmit(0)" size="small">暂存</el-button>
      <el-button @click="saveSubmit(1)" size="small">保存并发布</el-button>
    </div>
  </div>
</template>
<script>
import api from "../api";
export default {
  name: "applettop",
  props: ["property"],
  data() {
    return {
      fullscreenLoading: false,
      company: {
        pic: null,
        name: null
      }
    };
  },
  created(){
    this.InitFn()
  },
  methods: {
    InitFn() {
      this.axios
          .post(api.company_index, {})
          .then(response => {
            if (response.data.code == 0) {
              this.company.pic = response.data.info.pic
              this.company.name = response.data.info.name
            } else {
            }
          })
          .catch(response => {
          });
    },
    saveSubmit(option){
      // 发布状态(0仅保存、1发布)
      if(this.property.length === 0){
        this.$message({
          message: '请编辑相应的内容！',
          type: 'warning'
        });
        return
      }
      let data_ = []
      for(let i in this.property){
        let obj_ = {}
        obj_.type = this.property[i].type;
        obj_.content = this.property[i].content;
        
        if(this.property[i].type===13){
          // 团队管理
          for(let j in this.property[i].content.list){
            delete this.property[i].content.list[j].uname
            if(this.property[i].content.list[j].is_link==1 && !this.property[i].content.list[j].id){
              this.$message.error(this.property[i].content.label + '跳转到成员名片需选择要关联的成员')
              return
            }
          } 
          if(this.property[i].content.list.length!==0){
            data_.push(obj_);
          }                  
        }else if(this.property[i].type===15){
          // 企业招聘
          for(let j in this.property[i].content.list){
            if(!this.property[i].content.list[j].id){
              this.$message.error('企业招聘需添加相应招聘信息')
              return
            }
          }
          if(this.property[i].content.list.length!==0){
            data_.push(obj_);
          }
        }else{
          data_.push(obj_);
        }
      }
      // option
      const loading = this.$loading({
        lock: true,
        text: '努力保存中…',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.6)',
        color:"#fff"
      });

      this.axios
        .post(api.shopconf_set_website, {website:JSON.stringify(data_),release:option})
        .then(response => {
          if (response.data.code == 0) {
            loading.close();
            this.$notify({
              title: '操作成功',
              message: '您已保存成功',
              type: 'success'
            });
          } else {
          }
        })
        .catch(response => {
        });
    },
    clearModle(){
      this.$confirm('更换模版将删除当前模板中已编辑的内容，且删除的内容不可恢复，请谨慎操作。', '', {
        confirmButtonText: '继续',
        cancelButtonText: '取消',
        showClose: false,
        type: 'warning'
      }).then(() => {
        this.axios
            .post(api.shopconf_set_website, {website:JSON.stringify([]),release:0})
            .then(response => {
              if (response.data.code == 0) {
                this.$emit('changeInit')
                this.$notify({
                  title: '操作成功',
                  message: '您已更换模板成功',
                  type: 'success'
                });
              } else {
              }
            })
            .catch(response => {
            });
      }).catch(() => {
      });
    }
  }
};
</script>
